<template>
  <v-card>
    <div class="period-nav">
      <v-btn-toggle v-model="days" mandatory color="primary" class="period-toggle">
        <v-btn value="7" text>7 dias</v-btn>
        <v-btn value="15" text>15 dias</v-btn>
        <v-btn value="30" text>30 dias</v-btn>
        <v-btn value="4" text>4 meses</v-btn>
        <v-btn v-if="showExtendedPeriods" value="6" text>6 meses</v-btn>
        <v-btn v-if="showExtendedPeriods" value="all" text>Tudo</v-btn>
      </v-btn-toggle>
    </div>
    <line-chart
      v-if="loaded"
      :height="'200px'"
      :chart-data="graphicData"
      :chart-labels="graphicLabels"
      :annotations="annotations"
      :user-annotations="userAnnotations"
      :class="'CrisisChart'"
    ></line-chart>
  </v-card>
</template>

<script>
import LineChart from '../small/LineChart.vue'
import store from '../../store'

export default {
  components: { LineChart },
  name: 'SpasmsChart',
  props: {
    metrics: { type: Object },
    value: { type: [Number, String], default: 7 },
    annotations: { type: Array, default: () => [] },
    userAnnotations: { type: Array, default: () => [] }
  },
  data: function () {
    return {
      loaded: false,
      last7Days: [],
      last15Days: [],
      last30Days: [],
      last4Months: [],
      last6Months: [],
      allTime: [],
      graphicLabels: [],
      graphicData: []
    }
  },
  computed: {
    days: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    isDoctor() {
      const user = store.state.user
      return !!(user && user.profile && user.profile.profile_type === 'doctor')
    },
    isPro() {
      return !!(store.state.subscription && store.state.subscription.is_pro)
    },
    showExtendedPeriods() {
      return !this.isDoctor || this.isPro
    }
  },
  methods: {
    loadMetricsFor(days) {
      this.loaded = false
      let key = `last${days}Days`
      if (days == 4) key = 'last4Months'
      else if (days == 6) key = 'last6Months'
      else if (days === 'all') key = 'allTime'
      const dayMetrics = this[key]

      if (dayMetrics) {
        this.graphicLabels = dayMetrics.map(m => m.date)
        this.graphicData = dayMetrics.map(m => m.quantity)
        this.loaded = true
      }
    },
    fillDays(metrics, quantity) {
      const map = {}
      ;(metrics || []).forEach(m => { map[m.date] = m.quantity })
      const today = new Date()
      const result = []
      for (let i = quantity - 1; i >= 0; i--) {
        const d = new Date(today)
        d.setDate(d.getDate() - i)
        const label = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
        result.push({ date: label, quantity: map[label] || 0 })
      }
      return result
    },
    fillAllMonths(metrics) {
      if (!metrics || !metrics.length) return []
      const [firstMonth, firstYear] = metrics[0].date.split('/')
      const startDate = new Date(parseInt(firstYear), parseInt(firstMonth) - 1, 1)
      const today = new Date()
      const totalMonths = (today.getFullYear() - startDate.getFullYear()) * 12
        + (today.getMonth() - startDate.getMonth()) + 1
      return this.fillMonths(metrics, totalMonths)
    },
    fillMonths(metrics, quantity) {
      const map = {}
      ;(metrics || []).forEach(m => { map[m.date] = m.quantity })
      const today = new Date()
      const result = []
      for (let i = quantity - 1; i >= 0; i--) {
        const d = new Date(today.getFullYear(), today.getMonth() - i, 1)
        const label = `${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
        result.push({ date: label, quantity: map[label] || 0 })
      }
      return result
    },
    parseMetrics(metrics) {
      this.last7Days = this.fillDays(metrics.last_7_days, 7)
      this.last15Days = this.fillDays(metrics.last_15_days, 15)
      this.last30Days = this.fillDays(metrics.last_30_days, 30)
      this.last4Months = this.fillMonths(metrics.last_4_months, 4)
      this.last6Months = this.fillMonths(metrics.last_6_months, 6)
      this.allTime = this.fillAllMonths(metrics.all_time)
    }
  },
  watch: {
    metrics: {
      handler (newValue) {
        this.parseMetrics(newValue)
        this.loadMetricsFor(this.days)
      },
      deep: true
    },
    days: function (newValue) {
      this.loadMetricsFor(newValue)
    }
  },
  mounted: function () {
    this.parseMetrics(this.metrics)
    this.loadMetricsFor(this.days)
  }
}
</script>

<style scoped>
.period-nav {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.period-toggle {
  min-width: 100%;
}
.period-toggle::v-deep .v-btn {
  flex: 1 0 auto;
}
.CrisisChart {
  margin-top: 10px;
}
</style>
